export default __webpack_public_path__ + "static/media/ftp.077abd94.svg";